import createAction, { createOptimisticAction } from 'Store/utils/createAction';
import { fetchPrice, getProductArgs } from './priceTicket.helper';
import { PRICE_TICKET_REQUEST, PRICE_TICKET_REQUEST_ABORT } from './constants';
export function priceTicketRequest({
  appContext,
  duration,
  forceAdultPerTrip,
  location,
  productId,
  transport,
  withDate,
}: {
  appContext: AppContext;
  duration?: number;
  forceAdultPerTrip?: boolean;
  location: ProductRouterLocation;
  productId: string;
  transport?: string;
  withDate?: boolean;
}) {
  const productArgs = getProductArgs({
    duration,
    location,
    productId,
    transport,
    withDate,
  });
  return (dispatch: ReduxDispatch, getState: GetReduxState) => {
    const state = getState();

    if (state.priceTicket?.productArgs === productArgs) {
      return dispatch(createAction(PRICE_TICKET_REQUEST_ABORT, {}));
    }

    return dispatch(
      createOptimisticAction(
        PRICE_TICKET_REQUEST,
        {
          productArgs,
        },
        {
          optimist: true,
          promise: fetchPrice({
            appContext,
            duration,
            forceAdultPerTrip,
            location,
            productId,
            transport,
            withDate,
          }),
        },
      ),
    );
  };
}
